import FlexiToggle from "slotworks/graphics/elements/flexi-toggle";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AbstractToggleControl extends AbstractControl implements Control {

    protected toggle: FlexiToggle;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.toggle = layer.getFlexiToggle(assetName);
    }

    public setVisible(visible: boolean) {
        if (this.toggle) {
            this.toggle.setVisible(visible);
        }
    }

    public setEnabled(enabled: boolean) {
        if (this.toggle) {
            this.toggle.setEnabled(enabled);
        }
    }

    public destroy() {
        if (this.toggle) {
            this.toggle.destroy();
        }
    }
}
